import React from 'react'
import { 
  AiFillFacebook,
  AiFillTwitterCircle, 
  AiFillInstagram,
  AiFillLinkedin
} from 'react-icons/ai'
import { Link } from 'react-router-dom'

const TopNavBar = () => {
  return (
    <div className='w-full bg-green-600 md:p-4 p-3 text-white text-center'>
      <div className='flex flex-row items-center justify-center'>
        Mlimi Wamakono {' '}
        <span className='gap-x-3 mx-[10px] px-[5px] border-2 rounded-lg border-green-400 flex flex-row items-center'>
          <Link to={'https://facebook.com'} className='cursor-pointer'>
            <AiFillFacebook fontSize={20} /> 
          </Link>

          <Link to={'https://twitter.com'} className='cursor-pointer'>
            <AiFillTwitterCircle fontSize={20} />
          </Link>

          <Link to={'https://instagram.com'} className='cursor-pointer'>
            <AiFillInstagram fontSize={20} />
          </Link>

          <Link to={'https://linkedin.com'} className='cursor-pointer'>
            <AiFillLinkedin fontSize={20} />
          </Link>
        </span>
      </div>
    </div>
  )
}

export default TopNavBar
